//External
import React from "react";
import moment from "moment";
import { useSelector } from "react-redux";
//Internal
import { formatLocationDayTime, parseEarliestStart } from "utils/reservation";

/*******************
@Purpose : note under the booking dates using the later of the vehicle's
           lead time and an active flexible offer's pickup boundary
@Parameter : {startDate, vehicleId, flexibleAvailability}
******************/
const EarliestStartHint = ({ startDate, vehicleId, flexibleAvailability = null }) => {
  const { vehicleSlot } = useSelector(({ vehicle }) => vehicle);

  const isOtherVehicle =
    vehicleId !== undefined && (vehicleId === null || String(vehicleSlot?.vehicle_id) !== String(vehicleId));
  if (isOtherVehicle) return null;

  const vehicleEarliest = parseEarliestStart(vehicleSlot?.earliest_start);
  const adjusted = flexibleAvailability?.adjusted;
  const flexibleEarliest = flexibleAvailability?.adjustment === "available_from"
    ? moment(`${adjusted?.startDate} ${adjusted?.startTime}`, "MMM D, YYYY H:mm", true)
    : null;
  const hasFlexibleStart = Boolean(flexibleEarliest?.isValid());
  const earliest = hasFlexibleStart && (!vehicleEarliest || flexibleEarliest.isAfter(vehicleEarliest))
    ? flexibleEarliest
    : vehicleEarliest;
  if (!earliest) return null;

  const selected = startDate ? moment(startDate, ["MMM D, YYYY", "YYYY-MM-DD"]) : null;
  if (selected?.isValid() && selected.format("YYYY-MM-DD") > earliest.format("YYYY-MM-DD")) return null;

  return (
    <span className="earliest-start-hint d-block">
      {hasFlexibleStart ? "For this flexible offer, the earliest start is " : "Earliest available start is "}
      {formatLocationDayTime(earliest.format("YYYY-MM-DD HH:mm:ss"))}. Earlier times are not selectable.
    </span>
  );
};

export default EarliestStartHint;
